import React from 'react'
import { Routes, Route, Navigate } from 'react-router'
import Layout from './components/Layout'
import Home from './pages/Home'
import UserLogin from './pages/UserLogin'
import UserDashboard from './pages/UserDashboard'
import Dashboard from './pages/Dashboard'
import MeetupDetail from './pages/MeetupDetail'
import EmailResponse from './pages/EmailResponse'
import VerifyEmail from './pages/VerifyEmail'
import VerifyEmailChange from './pages/VerifyEmailChange'
import Unsubscribe from './pages/Unsubscribe'
import MagicLogin from './pages/MagicLogin'
import NotFound from './pages/NotFound'
import AdminMeetups from './pages/AdminMeetups'
import AdminUsers from './pages/AdminUsers'
import AdminEmails from './pages/AdminEmails'
import { AuthProvider } from './hooks/useAuth'
import { ThemeProvider } from './contexts/ThemeContext'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
      <Routes>
        {/* Publieke routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="meetup/:id" element={<MeetupDetail />} />
        </Route>

        {/* User routes */}
        <Route path="/login" element={<Layout />}>
          <Route index element={<UserLogin />} />
        </Route>
        <Route path="/magic-login" element={<Layout />}>
          <Route index element={<MagicLogin />} />
        </Route>
        <Route path="/dashboard" element={<Layout />}>
          <Route index element={<UserDashboard />} />
        </Route>

        {/* Email response routes (geen layout) */}
        <Route path="/respond/:token/:meetupId/:action" element={<EmailResponse />} />
        <Route path="/verify/:token" element={<VerifyEmail />} />
        <Route path="/verify-email-change/:token" element={<VerifyEmailChange />} />
        <Route path="/unsubscribe/:token" element={<Unsubscribe />} />

        {/* Admin routes */}
        <Route path="/admin" element={<Layout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          {/* Inloggen gaat voor iedereen via een code per e-mail; oude links (ook uit
              eerder verstuurde admin-mails) komen op /login uit. */}
          <Route path="login" element={<Navigate to="/login" replace />} />
          <Route path="forgot-password" element={<Navigate to="/login" replace />} />
          <Route path="reset-password" element={<Navigate to="/login" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="meetups" element={<AdminMeetups />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="emails" element={<AdminEmails />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
    </ThemeProvider>
  )
}

export default App